var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointOnly16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point_only_16x16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 16.002A8 8 0 1 0 8 0a8 8 0 0 0 0 16.002Z",
  fill: "#2D91FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.38 4.35c0-.29.235-.522.523-.522h2.651c.811 0 1.5.276 2.067.827.56.552.84 1.228.84 2.03 0 .804-.28 1.481-.84 2.031-.568.552-1.257.826-2.067.826H7.06v1.877a.84.84 0 0 1-1.678 0v-7.07Zm1.68 3.624h1.494c.357 0 .653-.124.887-.371.235-.248.352-.554.352-.919s-.117-.68-.352-.923a1.182 1.182 0 0 0-.887-.365H7.06v2.578Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "point_only_16x16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgPointOnly16X16;